export const basicFormData = () => ({
  inputData: {
    city_name: "",
    state_id: "",
    is_active: true,
    created_by: null,
    updated_by: null,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "city_masters",
  };

  const navigatePage = { back: "/city-list" };

  const headerName = "City";

  const validationType = "CityCreate";
  const createEndpoint = "/createCity";
  const updateEndpoint = "/updateCity";
  const getEndpoint = "/getCityById";
  const dependentDropdownData = [
    {
      module_name: "state_masters",
      initialPayload: {
        modelName: "state_masters",
        whereCondition: {
          is_active: true,
        },
      },
      isOtherDependentOnThis: true,
      patchFieldName: "state_name",
      dropdownDataValue: "state_id",
      endPoint: "/listState",
    },
    // {
    //   module_name: "city_masters",
    //   initialPayload: { modelName: "city_masters" },
    //   isOtherDependentOnThis: false,
    //   isDepenetOn: "state_masters",
    //   patchFieldName: "city_name",
    //   dropdownDataValue: "city_id",
    //   endPoint: "/listState",
    // },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "city_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
      {
        module: "state_masters",
        moduleAs: "state_masters",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "State Name", value: "state_masters.state_name" },
    { label: "City Name", value: "city_name" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/city-create",
    edit: "/city-create",
    view: "/city-view",
  };

  const searchfields = [
    "city_name",
    "state_masters.state_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "City";
  const endpoint = "/listCity";
  const exportFileName = "cityData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};
export const exportPageData = {
  modelName: "city_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
    {
      module: "state_masters",
      moduleAs: "state_masters",
    },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
